import {
  ApiListRequest,
  ApiListResponse,
  ProductCategoryDTO,
  ProductDTO,
} from "@gymflow/types";
import { infiniteQueryOptions, QueryKey } from "@tanstack/react-query";

import { api } from "../../api";
import { numberPagination } from "../../numberPagination";

const keys = {
  all: () => ["hostedApiProduct"] as QueryKey,
  list: (filter: unknown) => [...keys.all(), "list", filter] as QueryKey,
  listCategories: (filter: unknown) =>
    [...keys.all(), "listCategories", filter] as QueryKey,
};

export const hostedApiProduct = {
  keys,
  queries: {},
  infiniteQueries: {
    list: (
      params: {
        productCategoriesIncluded?: number[];
        allowAppPurchases?: boolean;
        allowWebPurchases?: boolean;
      } & ApiListRequest,
    ) =>
      infiniteQueryOptions({
        queryKey: keys.list(params),
        queryFn: async ({ pageParam }) => {
          return (
            await api.get<ApiListResponse<ProductDTO>>(
              `/hosted/product/available`,
              {
                params: { ...params, page: pageParam },
              },
            )
          ).data;
        },
        ...numberPagination,
      }),
    listCategories: (params: ApiListRequest) =>
      infiniteQueryOptions({
        queryKey: keys.listCategories(params),
        queryFn: async ({ pageParam }) => {
          const result = (
            await api.get<ProductCategoryDTO[]>(
              `/hosted/catalog/product/category`,
              {
                params: { ...params, page: pageParam },
              },
            )
          ).data;
          // this mapping is needed because the /hosted & /member interfaces are different
          return {
            empty: false,
            first: true,
            last: true,
            number: 0,
            numberOfElements: result.length,
            pageable: "INSTANCE",
            size: result.length,
            sort: {
              empty: true,
              sorted: false,
              unsorted: true,
            },
            totalElements: result.length,
            totalPages: 1,
            content: result,
          } as ApiListResponse<ProductCategoryDTO>;
        },
        ...numberPagination,
      }),
  },
  mutations: {},
};
